import React, { createContext, FC, useState, ReactNode } from 'react';

export type FacetValue = {
  value: string;
  state: 'idle' | 'selected';
  numberOfResults: number;
};

type SearchBoxContextType = {
  selectedVersion?: FacetValue;
  setSelectedVersion: (version?: FacetValue) => void;
  showSearchResult: boolean;
  setShowSearchResult: (show: boolean) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
};

const initialState = {
  selectedVersion: undefined,
  showSearchResult: false,
  searchQuery: '',
};

export const SearchBoxContext = createContext<SearchBoxContextType>({
  selectedVersion: initialState.selectedVersion,
  setSelectedVersion: () => {},
  showSearchResult: initialState.showSearchResult,
  setShowSearchResult: () => {},
  searchQuery: initialState.searchQuery,
  setSearchQuery: () => {},
});

type ProviderProps = {
  children: ReactNode;
};

export const SearchBoxResultShowProvider: FC<ProviderProps> = ({ children }) => {
  const [selectedVersion, setSelectedVersion] = useState<FacetValue | undefined>(initialState.selectedVersion);
  const [showSearchResult, setShowSearchResult] = useState(initialState.showSearchResult);
  const [searchQuery, setSearchQuery] = useState(initialState.searchQuery);

  return (
    <SearchBoxContext.Provider
      value={{
        selectedVersion,
        setSelectedVersion,
        showSearchResult,
        setShowSearchResult,
        searchQuery,
        setSearchQuery,
      }}
    >
      {children}
    </SearchBoxContext.Provider>
  );
};
